// Official Seasons Art Class — East Croydon logo (served from /public)
export const LOGO_URL = "/logo.png";

// Real studio photos sourced from the existing artclassesineastcroydon.co.uk site.
// These show the actual East Croydon classroom (adults at tables with drawing boards — no easels)
// and real student finished pieces (drawing, oil pastel, watercolour, acrylic).
const WIX = "https://static.wixstatic.com/media";
const fill = (uri, w = 1400, h = 1050, fp = "0.50_0.50") =>
  `${WIX}/${uri}/v1/fill/w_${w},h_${h},fp_${fp},q_90/${uri}`;

export const IMG = {
  // Hero — the actual East Croydon studio: adults at tables with drawing boards
  hero: fill("e0302f_fc5afd302ee343d1bf5fa0a0c81d4072~mv2.jpg", 1400, 1750),
  // Pansies watercolour lesson (landscape)
  heroSecondary: fill("e0302f_8e9eb9659e9241389ff6ebc6b63a4c76~mv2.jpg", 1400, 900, "0.35_0.23"),
  // Drawing — Living Room Sketch (pencil)
  drawing: fill("8b9f9dd9d9ca4bbdaefcad0881874c09.jpg", 1200, 900),
  // Oil Pastel — real student oil pastel piece
  oilPastel: fill("e0302f_a36aa7494fbb41ed95a0faa09495cb06~mv2.jpg", 1200, 900),
  // Watercolour — Tea Cup in Watercolor (student piece)
  watercolor: fill("c8251f8f211e4ff6a5a45c288c2afdd1.jpg", 1200, 900),
  // Acrylic — Light on Painting (student acrylic)
  acrylic: fill("278282ef997d4cd3ae001307f59738f9.jpg", 1200, 900),
  // Tutor / studio moment — repurpose main studio photo cropped tighter
  tutor: fill("e0302f_fc5afd302ee343d1bf5fa0a0c81d4072~mv2.jpg", 1200, 1500, "0.40_0.40"),
  // Extra marquee images — paints spread + class lesson
  studioA: fill("7e803a05bd484a31bd894b830c68e287.jpg", 1000, 1250),
  studioB: fill("e0302f_8e9eb9659e9241389ff6ebc6b63a4c76~mv2.jpg", 1000, 1250, "0.50_0.50"),
  // Studio logo (used on vouchers + email branding) — defaults to the
  // bundled PNG; admins can override via Admin → Site images.
  logo: LOGO_URL,
};
